import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=433f20a6&scoped=true&"
import script from "./Pager.vue?vue&type=script&lang=js&"
export * from "./Pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f20a6",
  null
  
)

export default component.exports